/**
 * Post typing declarations, basically a copy of the gql schema.
 */

import { TagCollection, ShortTag } from "./Tag";

export enum ContentRatings {
    SAFE = "s",
    QUESTIONABLE = "q",
    EXPLICIT = "e",
}

export interface Post<T> {
    id: number;
    score: number;
    fav_count: number;
    file_url: string;
    file_ext: "jpg" | "png" | "gif" | "swf" | "webm" | "mp4";
    tags: T;
    rating: ContentRatings;
    height: number;
    artist: string[];
}

export type ShortPost = Post<TagCollection<ShortTag>>;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/schemas/Post.ts